module.exports = __webpack_public_path__ + "src/assets/img/contentdelivery.c4c096cd.jpg";